// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as Prioritize2$Showside from "../utils/Prioritize2.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as SmartNavVideo$Showside from "./SmartNavVideo.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function CategoryCard$CardVideo(Props) {
  var imageUrl = Props.imageUrl;
  var videoUrl = Props.videoUrl;
  var settings = Props.settings;
  var showIndicatorOpt = Props.showIndicator;
  var controlsClassNameOpt = Props.controlsClassName;
  var parentRef = Props.parentRef;
  var alt = Props.alt;
  var fitToContainer = Props.fitToContainer;
  var onImageRendered = Props.onImageRendered;
  var showIndicator = showIndicatorOpt !== undefined ? showIndicatorOpt : false;
  var controlsClassName = controlsClassNameOpt !== undefined ? controlsClassNameOpt : "";
  LCPContext$Showside.use(undefined);
  UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var match = React.useState(function () {
    return false;
  });
  var setCanRenderVideoCard = match[1];
  var canRenderVideoCard = match[0];
  var onLoad = React.useCallback(function (param) {
    Curry._1(setCanRenderVideoCard, function (param) {
      return true;
    });
  }, [setCanRenderVideoCard]);
  return React.createElement(Prioritize2$Showside.make, {
    render: function (priority) {
      var tmp;
      if (imageUrl !== undefined) {
        var tmp$1 = {
          src: imageUrl,
          fit: fitToContainer ? /* Contain */2 : /* Cover */1,
          alt: alt,
          priority: priority,
          onLoad: onLoad
        };
        if (onImageRendered !== undefined) {
          tmp$1.onRender = Caml_option.valFromOption(onImageRendered);
        }
        tmp = React.createElement(SmartImg$Showside.make, tmp$1);
      } else {
        tmp = null;
      }
      var tmp$2 = {
        src: videoUrl,
        controlsClassName: controlsClassName,
        alt: alt,
        showIndicator: showIndicator,
        autoplay: settings.videoAutoPlay,
        loop: settings.videoLoop,
        muted: settings.videoMute,
        controls: settings.videoControls
      };
      if (parentRef !== undefined) {
        tmp$2.parentRef = Caml_option.valFromOption(parentRef);
      }
      return React.createElement(React.Fragment, undefined, tmp, React.createElement(ConditionalRender$Showside.When.make, {
        condition: imageUrl === undefined || canRenderVideoCard,
        children: React.createElement(SmartNavVideo$Showside.make, tmp$2)
      }));
    },
    key: videoUrl
  });
}
CategoryCard$CardVideo.displayName = "CategoryCard.CardVideo";
var CardVideo = {
  make: CategoryCard$CardVideo
};
function CategoryCard$Default(Props) {
  var category = Props.category;
  var id = Props.id;
  var shape = Props.shape;
  var fluidOpt = Props.fluid;
  var renderOverlay = Props.renderOverlay;
  var showTitleOpt = Props.showTitle;
  var roundedOpt = Props.rounded;
  var forcedOpenLinkOpt = Props.forcedOpenLink;
  var showDescriptionOpt = Props.showDescription;
  var imageFitToContainer = Props.imageFitToContainer;
  var titleTextSize = Props.titleTextSize;
  var style = Props.style;
  var inspectable = Props.inspectable;
  var onClick = Props.onClick;
  var onImageRendered = Props.onImageRendered;
  var fluid = fluidOpt !== undefined ? fluidOpt : false;
  var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
  var rounded = roundedOpt !== undefined ? roundedOpt : true;
  var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : false;
  var showDescription = showDescriptionOpt !== undefined ? showDescriptionOpt : true;
  var id$1 = Belt_Option.getWithDefault(id, "category-card-" + category.id);
  var nodeId = category.id;
  var isSocialNetworkContent = category.socialNetworkSource !== undefined;
  var dataTestId = isSocialNetworkContent ? "social-network-post" : "category-card-test-id";
  var titleDataTestId = isSocialNetworkContent ? "social-network-post-title" : "category-card-title";
  var match = category.categoryType;
  var tmp;
  tmp = typeof match === "number" || match.TAG !== /* QuickView */2 ? "category-card" : "quickview-card";
  var inspectable$1 = Belt_Option.getWithDefault(inspectable, tmp);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$1.config.settings;
  var ref = React.useRef(null);
  var imageFitToContainer$1 = Belt_Option.getWithDefault(imageFitToContainer, settings.categoryCardFitToContainer);
  var renderCardVideo = function (fallbackImageUrl, videoUrl) {
    var tmp = {
      videoUrl: videoUrl,
      settings: settings,
      parentRef: ref,
      alt: category.title,
      fitToContainer: imageFitToContainer$1
    };
    if (fallbackImageUrl !== undefined) {
      tmp.imageUrl = Caml_option.valFromOption(fallbackImageUrl);
    }
    if (onImageRendered !== undefined) {
      tmp.onImageRendered = Caml_option.valFromOption(onImageRendered);
    }
    return React.createElement(CategoryCard$CardVideo, tmp);
  };
  var renderAfterTitle = React.useCallback(function (param) {
    var textAlignmentCn = shape === 0 ? "text-center" : "";
    var description = category.description;
    if (description !== undefined && showDescription && category.showDescription) {
      return Caml_option.some(React.createElement(DataAttribute$Showside.make, {
        dataTestId: "category-description",
        children: React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["line-clamp-2 text-secondary text-base max-w-lg mt-1", textAlignmentCn]))
        }, Curry._1(StringUtils$Showside.stripHTML, description))
      }));
    }
  }, [shape, category]);
  var title = showTitle && category.showTitle ? category.title : undefined;
  var imageSize = Category$Showside.getCategoryImageSize(category);
  var handleClick = React.useMemo(function () {
    var match = category.card;
    var exit = 0;
    switch (match.TAG | 0) {
      case /* ImageLinkCard */0:
      case /* VideoLinkCard */1:
        exit = 2;
        break;
      case /* ImageDisplayCard */6:
      case /* VideoDisplayCard */7:
        return;
      default:
    }
    if (exit === 2 && Belt_Option.isSome(Category$Showside.Link.getURL(match._0.link))) {
      return;
    }
    return Belt_Option.map(onClick, function (fn, param) {
      Curry._1(fn, category);
    });
  }, [onClick, category]);
  var match$2 = category.card;
  var cardLink;
  switch (match$2.TAG | 0) {
    case /* ImageLinkCard */0:
    case /* VideoLinkCard */1:
    case /* MedialessLinkCard */5:
      cardLink = match$2._0.link;
      break;
    case /* ImageDisplayCard */6:
    case /* VideoDisplayCard */7:
      cardLink = undefined;
      break;
    default:
      cardLink = match$2._0.link;
  }
  var match$3 = category.card;
  var preventLinkDefault;
  switch (match$3.TAG | 0) {
    case /* ImageLinkCard */0:
    case /* VideoLinkCard */1:
    case /* MedialessLinkCard */5:
      preventLinkDefault = false;
      break;
    case /* ImageDisplayCard */6:
    case /* VideoDisplayCard */7:
      preventLinkDefault = true;
      break;
    default:
      preventLinkDefault = !forcedOpenLink;
  }
  var match$4 = category.card;
  var cardMedia;
  var exit = 0;
  var imageUrl;
  switch (match$4.TAG | 0) {
    case /* ImageLinkCard */0:
      imageUrl = match$4._0.imageUrl;
      exit = 1;
      break;
    case /* VideoLinkCard */1:
      var match$5 = match$4._0;
      cardMedia = renderCardVideo(match$5.fallbackImageUrl, match$5.videoUrl);
      break;
    case /* ImageCard */2:
      imageUrl = match$4._0.imageUrl;
      exit = 1;
      break;
    case /* VideoCard */3:
      var match$6 = match$4._0;
      cardMedia = renderCardVideo(match$6.fallbackImageUrl, match$6.videoUrl);
      break;
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
      exit = 2;
      break;
    case /* ImageDisplayCard */6:
      imageUrl = match$4._0.imageUrl;
      exit = 1;
      break;
    case /* VideoDisplayCard */7:
      var match$7 = match$4._0;
      cardMedia = renderCardVideo(match$7.fallbackImageUrl, match$7.videoUrl);
      break;
  }
  switch (exit) {
    case 1:
      cardMedia = React.createElement(Prioritize2$Showside.make, {
        render: function (priority) {
          var tmp = {
            src: imageUrl,
            fit: imageFitToContainer$1 ? /* Contain */2 : /* Cover */1,
            alt: category.title,
            priority: priority
          };
          if (onImageRendered !== undefined) {
            tmp.onRender = Caml_option.valFromOption(onImageRendered);
          }
          return React.createElement(SmartImg$Showside.make, tmp);
        },
        key: imageUrl
      });
      break;
    case 2:
      cardMedia = React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-0 bg-placeholder")
      });
      break;
  }
  var tmp$1 = {
    shape: shape,
    fluid: fluid,
    id: id$1,
    nodeId: nodeId,
    preventLinkDefault: preventLinkDefault,
    lineClamp: settings.categoryCardTitleLineTruncate,
    openLinkInNewTab: settings.openLinkInNewTab,
    inspectable: inspectable$1,
    rounded: rounded,
    contentBoxStylableClassName: "category-card__content-box",
    titleStylableClassName: "category-card__title",
    imageSize: imageSize,
    fwdRef: ref,
    dataTestId: dataTestId,
    titleDataTestId: titleDataTestId,
    children: cardMedia,
    renderAfterTitle: renderAfterTitle
  };
  if (cardLink !== undefined) {
    tmp$1.link = Caml_option.valFromOption(cardLink);
  }
  if (titleTextSize !== undefined) {
    tmp$1.titleTextSizeDesktop = Caml_option.valFromOption(titleTextSize);
  }
  if (titleTextSize !== undefined) {
    tmp$1.titleTextSizeMobile = Caml_option.valFromOption(titleTextSize);
  }
  if (title !== undefined) {
    tmp$1.title = Caml_option.valFromOption(title);
  }
  if (renderOverlay !== undefined) {
    tmp$1.renderOverlay = Caml_option.valFromOption(renderOverlay);
  }
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  if (handleClick !== undefined) {
    tmp$1.onClickDiv = Caml_option.valFromOption(handleClick);
  }
  if (handleClick !== undefined) {
    tmp$1.onClickLink = Caml_option.valFromOption(handleClick);
  }
  return React.createElement(Card$Showside.make, tmp$1);
}
CategoryCard$Default.displayName = "CategoryCard.Default";
var Default = {
  make: CategoryCard$Default
};
function CategoryCard(Props) {
  var category = Props.category;
  var id = Props.id;
  var shape = Props.shape;
  var fluidOpt = Props.fluid;
  var renderOverlay = Props.renderOverlay;
  var showVideoIndicatorOpt = Props.showVideoIndicator;
  var showProductCountOpt = Props.showProductCount;
  var showTitleOpt = Props.showTitle;
  var roundedOpt = Props.rounded;
  var forcedOpenLinkOpt = Props.forcedOpenLink;
  var showDescriptionOpt = Props.showDescription;
  var videoControlsClassNameOpt = Props.videoControlsClassName;
  var imageFitToContainer = Props.imageFitToContainer;
  var titleTextSize = Props.titleTextSize;
  var style = Props.style;
  var inspectable = Props.inspectable;
  var onClick = Props.onClick;
  var onImageRendered = Props.onImageRendered;
  var fluid = fluidOpt !== undefined ? fluidOpt : false;
  var showVideoIndicator = showVideoIndicatorOpt !== undefined ? showVideoIndicatorOpt : false;
  var showProductCount = showProductCountOpt !== undefined ? showProductCountOpt : true;
  var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
  var rounded = roundedOpt !== undefined ? roundedOpt : true;
  var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : false;
  var showDescription = showDescriptionOpt !== undefined ? showDescriptionOpt : true;
  var videoControlsClassName = videoControlsClassNameOpt !== undefined ? videoControlsClassNameOpt : "";
  var tmp = {
    category: category,
    shape: shape,
    fluid: fluid,
    showVideoIndicator: showVideoIndicator,
    showProductCount: showProductCount,
    showTitle: showTitle,
    rounded: rounded,
    forcedOpenLink: forcedOpenLink,
    showDescription: showDescription,
    videoControlsClassName: videoControlsClassName
  };
  if (id !== undefined) {
    tmp.id = id;
  }
  if (renderOverlay !== undefined) {
    tmp.renderOverlay = Caml_option.valFromOption(renderOverlay);
  }
  if (imageFitToContainer !== undefined) {
    tmp.imageFitToContainer = Caml_option.valFromOption(imageFitToContainer);
  }
  if (titleTextSize !== undefined) {
    tmp.titleTextSize = Caml_option.valFromOption(titleTextSize);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  if (inspectable !== undefined) {
    tmp.inspectable = Caml_option.valFromOption(inspectable);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (onImageRendered !== undefined) {
    tmp.onImageRendered = Caml_option.valFromOption(onImageRendered);
  }
  return React.createElement(CategoryCard$Default, tmp);
}
CategoryCard.displayName = "CategoryCard";
var make = React.memo(CategoryCard);
export { CardVideo, Default, make };
/* make Not a pure module */